/**
 * Rescales a canvas element and its context to account for device pixel ratio (DPR)
 * to ensure crisp rendering on high DPI displays.
 *
 * @param canvas - The HTML canvas element to rescale
 * @param ctx - The 2D rendering context of the canvas
 * @param imageHeightAndWidth - Object containing the desired display width and height
 */
export const rescaleCanvas = (
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  imageHeightAndWidth: { width: number; height: number },
) => {
  const dpr = window.devicePixelRatio || 1;

  const displayWidth = imageHeightAndWidth.width;
  const displayHeight = imageHeightAndWidth.height;

  canvas.width = displayWidth * dpr;
  canvas.height = displayHeight * dpr;

  canvas.style.width = `${displayWidth}px`;
  canvas.style.height = `${displayHeight}px`;

  ctx.scale(dpr, dpr);
};
